import { HttpErrorResponse } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { ObservableStatus } from '../enums/observable-status-enum';
import { ObservableStatusResult } from '../models/observable-status.model';

@Pipe({
  name: 'flyObservableStatus',
  standalone: false
})
export class ObservableStatusPipe implements PipeTransform {
  transform<T>(observable: Observable<T>): Observable<ObservableStatusResult<T>> {
    return observable.pipe(
      map((value: T) => ({ status: ObservableStatus.LOADED, value })),
      startWith({ status: ObservableStatus.LOADING }),
      catchError((error) => {
        let statusCode = -1; // Default status code for non-HTTP errors
        if (error instanceof HttpErrorResponse) {
          statusCode = error.status;
        }
        return of({ status: ObservableStatus.ERROR, statusCode, errorMessage: this.extractErrorMessage(error) });
      })
    );
  }

  private extractErrorMessage(error: any): string {
    if (typeof error === 'string') {
      return error;
    } else if (error.message !== undefined && error.message !== null) {
      return error.message;
    } else {
      return 'An error occurred';
    }
  }
}
